import React from "react";

const Asterisk =()=>{
    return (
        <span style={{color:"red"}}>*</span>
    )
}

export default Asterisk;